import React, { FC } from "react";
import { P } from "theme/typography";
import { SxProps, TypographyPropsVariantOverrides, Theme, Box } from "@mui/material";
import { Variant } from "@mui/material/styles/createTypography";
import { OverridableStringUnion } from "@mui/types";

interface TextTabProps {
  active: boolean;
  click: () => void;
  sx?: SxProps<Theme>;
  variant?: OverridableStringUnion<Variant | "inherit", TypographyPropsVariantOverrides>;
  id?: string;
  children: React.ReactNode;
}

export const TextTab: FC<TextTabProps> = (props) => {
  const { active, children, click, sx, variant, id } = props;
  const s: SxProps<Theme> = sx || {};
  const v = variant || "body1";

  return (
    <>
      {active && (
        <P variant={v} sx={{ ...s, textDecoration: "underline", fontWeight: 700 }} id={id}>
          {children}
        </P>
      )}
      {!active && (
        <Box sx={{ cursor: "pointer" }} onClick={() => click()} id={id}>
          <P variant={v} sx={{ color: "grey.200", "&:hover": { color: "grey.900" }, ...s }}>
            {children}
          </P>
        </Box>
      )}
    </>
  );
};
